import React from 'react';
import { ReactComponent as IOS1 } from "../../assets/image/svg/ios1.svg";
import { ReactComponent as IOS2 } from "../../assets/image/svg/ios2.svg";
import { ReactComponent as IOS3 } from "../../assets/image/svg/ios3.svg";
import { PhoneFrame, Overlay } from './index';

const IOS_W = 510;
const IOS_H = 1025;

function IOSInstallScreen1({ whiteLabel }) {
  return (
    <PhoneFrame Svg={IOS1}>
      <div className="ios-step1-content">
        <img src={whiteLabel?.mobile_logo} className="logo" style={{ padding: 0 }} />
        <span style={{ fontSize: 'clamp(18px, 2vw, 22px)', fontWeight: 600 }}>
          {whiteLabel?.company_name || "Move2Order"}
        </span>
      </div>
    </PhoneFrame>
  );
}

function IOSInstallScreen2({ whiteLabel }) {
  const X = 35;
  const Y = 135;
  return (
    <PhoneFrame Svg={IOS2}>
      <Overlay x={X} y={Y} svgW={IOS_W} svgH={IOS_H}>
        <div className="ios-step2-content">
          <div className="logo-box" style={{ width: "clamp(28px, 5%, 48px)", height: "clamp(28px, 5%, 48px)", minWidth: "28px", minHeight: "28px", flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src={whiteLabel?.mobile_logo}
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <div style={{ lineHeight: 1.1, marginTop:'2px', minWidth: 0, flex: 1 }}>
            <div className="step-title" style={{ fontSize: 'clamp(10px, 1.2vw, 14px)' }}>
              {whiteLabel?.company_name || "Move2Order"}
            </div>
            <div className="step-domain" style={{ fontSize: 'clamp(8px, 0.9vw, 11px)', marginTop:'1px', width: 'auto', maxWidth: '100%' }}>
              {whiteLabel?.domain || "move2order.com"}
            </div>
          </div>
        </div>
      </Overlay>
    </PhoneFrame>
  );
}

function IOSInstallScreen3({ whiteLabel }) {
  return (
    <PhoneFrame Svg={IOS3}>
      <Overlay x={35} y={177} svgW={IOS_W} svgH={IOS_H}>
        <div className="ios-step3-content">
          <div style={{ width: "clamp(40px, 12%, 60px)", height: "clamp(40px, 12%, 60px)", flexShrink: 0 }}>
            <img
              src={whiteLabel?.mobile_logo}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: '2px', minWidth: 0, flex: 1 }}>
            <span className="step-title" style={{ fontSize: 'clamp(10px, 1.4vw, 14px)' }}>
              {whiteLabel?.company_name || "Move2Order"}
            </span>
            <span className="step-domain" style={{ fontSize: 'clamp(8px, 1vw, 11px)', width: 'auto', maxWidth: '100%' }}>
              {whiteLabel?.domain || "move2order.com"}
            </span>
          </div>
        </div>
      </Overlay>
    </PhoneFrame>
  );
}

export const iosSteps = [
  {
    title: '1.',
    description: 'Click on the share button as shown in the picture.',
    content: IOSInstallScreen1,
  },
  {
    title: '2.',
    description: 'Click on "Add to Home Screen"',
    content: IOSInstallScreen2,
  },
  {
    title: '3.',
    description: 'Click on "Add"',
    content: IOSInstallScreen3,
  },
];
